import { render, staticRenderFns } from "./tardiness-stat.vue?vue&type=template&id=2322dd14&scoped=true&"
import script from "./tardiness-stat.js?vue&type=script&lang=js&"
export * from "./tardiness-stat.js?vue&type=script&lang=js&"
import style0 from "./tardiness-stat.scss?vue&type=style&index=0&id=2322dd14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2322dd14",
  null
  
)

export default component.exports